import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./BookListPages.css";
import "./GeneralRulesPage.css";

function GeneralRulesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundColor = "#ffffff";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <div className="general-rules-page app-shell-page">
      <div className="container-fluid px-3 px-md-4 pt-3 pb-5">
        <div className="book-list-page__titlebar mb-2">
          <button
            type="button"
            className="book-list-page__back"
            onClick={() => navigate("/profile")}
            aria-label="Back to pro file"
          >
            <span className="material-symbols-rounded">arrow_back</span>
          </button>
          <div className="book-list-page__header">
            <h3 className="mb-0">General Rules</h3>
          </div>
        </div>

        <div className="general-rules-page__content">
          <div className="epub-subtitle fw-semibold mb-2 mt-4">INFO</div>
          <p className="epub-body-text fw-normal mb-4">
            While this is an app for both books and fics, please keep in mind most of its users are fixed shippers. Ensure fic uploads are limited to TMRHP and, in the case of ongoing fics, specify in the uploader notes if there’s any content people should be worried for as added chapters are Not part of the epub file itself, and thus don’t have updated tags.
          </p>

          <div className="epub-subtitle fw-semibold mb-2">ADDED CHAPTERS</div>
          <p className="epub-body-text fw-normal mb-4">
            The app itself works best with complete fics/books, so to free up space in our servers, maybe wait for a fic to be complete before uploading it here? Added chapters take up more space than an epub file would (as it has everything already neatly zipped inside it), so if u can, avoid incomplete fics unless they’re already super long (like 100k+). This will help keep server costs for me low.
          </p>

          <div className="epub-subtitle fw-semibold mb-2">COMMENTARY</div>
          <p className="epub-body-text fw-normal mb-4">
            And of course, there’s no limits to what content you can upload, go crazy with the dead dove idgaf, but be nice in the comments and Please use the export feature in the annotations tab to send a copy of your commentary to the author!
          </p>

          <div className="epub-subtitle fw-semibold mb-2">IMPORTANT</div>
          <p className="epub-body-text fw-normal mb-0">
            Another thing to watch out for; if you see comments appearing paragraphs earlier than they should, it means the epub you uploaded was not correctly formatted to begin with. Comments happen on {"<p>"} tags, and if within those tags you have a break ({"<br>"}), the code will assume the whole thing is just one giant block of text even if sentences appear visually separated.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GeneralRulesPage;
